















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class BasicHeader extends Vue {
  @Prop({ required: true })
  readonly image!: string;

  @Prop({ required: true })
  readonly textItems!: any;
}
